export const REMOVE_STALE_PAST_CONVERSATIONS = 'REMOVE_STALE_PAST_CONVERSATIONS';